var routes = [{
  path: '/api-reference',
  name: 'api-reference',
  component: function component() {
    return import('layouts/Blank.vue');
  },
  meta: {
    // guest: true,
    shortcut: false
  },
  children: [{
    path: '',
    component: function component() {
      return import('pages/Api.vue');
    }
  }]
}, {
  path: '/signup',
  name: 'signup',
  component: function component() {
    return import('layouts/Blank.vue');
  },
  meta: {
    guest: true,
    shortcut: false
  },
  children: [{
    path: '',
    component: function component() {
      return import('pages/Signup.vue');
    }
  }]
}, {
  path: '/microsoft-subscription-resolve',
  name: 'microsoft-subscription-resolve',
  component: function component() {
    return import('layouts/Blank.vue');
  },
  meta: {
    shortcut: false
  },
  children: [{
    path: '',
    component: function component() {
      return import('pages/MicrosoftSubscriptionResolve.vue');
    }
  }]
}, {
  path: '/password',
  name: 'password',
  component: function component() {
    return import('layouts/Login.vue');
  },
  meta: {
    guest: true,
    shortcut: false
  },
  children: [{
    path: 'forgot-password',
    component: function component() {
      return import('pages/PasswordSendReset.vue');
    }
  }, {
    path: 'reset/:token',
    component: function component() {
      return import('pages/PasswordReset.vue');
    }
  }]
}, {
  path: '/email-verify',
  name: 'email-verify',
  component: function component() {
    return import('layouts/Login.vue');
  },
  meta: {
    guest: true,
    shortcut: false
  },
  children: [{
    path: '',
    component: function component() {
      return import('pages/EmailVerify.vue');
    }
  }]
}, {
  path: '/login',
  name: 'login',
  component: function component() {
    return import('layouts/Login.vue');
  },
  meta: {
    guest: true,
    shortcut: false
  },
  children: [{
    path: ':service',
    component: function component() {
      return import('pages/Login.vue');
    },
    children: [{
      path: '',
      name: 'login',
      component: function component() {
        return import('pages/Login.vue');
      }
    }, {
      path: 'callback',
      component: function component() {
        return import('pages/Login.vue');
      }
    }]
  }, {
    path: '',
    component: function component() {
      return import('pages/Login.vue');
    }
  }]
}, {
  path: '/user-setup',
  name: 'user_setup',
  component: function component() {
    return import('layouts/Blank.vue');
  },
  children: [{
    name: 'user-setup',
    path: '',
    component: function component() {
      return import('pages/Setup.vue');
    }
  }]
}, {
  path: '/setup',
  name: 'setup',
  component: function component() {
    return import('layouts/Blank.vue');
  },
  meta: {
    // auth: true,
    setupCompleted: false,
    shortcut: false
  },
  children: [{
    path: '',
    name: 'setup',
    component: function component() {
      return import('pages/Setup.vue');
    }
  }]
}, {
  path: '/teams/auth/:service_code',
  component: function component() {
    return import('layouts/Blank.vue');
  },
  meta: {
    // guest: true,
    shortcut: false
  },
  children: [{
    path: '',
    component: function component() {
      return import('pages/TeamsAuth.vue');
    }
  }]
}, {
  path: '/integration-auth/:integration_code',
  component: function component() {
    return import('layouts/Blank.vue');
  },
  meta: {
    subscribed: false,
    shortcut: false
  },
  children: [{
    path: '',
    component: function component() {
      return import('pages/IntegrationAuth.vue');
    }
  }]
}, {
  path: '/unauthorized',
  name: 'unauthorized',
  component: function component() {
    return import('layouts/Blank.vue');
  },
  meta: {
    owner: false,
    subscribed: false,
    auth: false
  },
  children: [{
    path: '',
    name: 'unauthorized',
    component: function component() {
      return import('pages/Unauthorized.vue');
    }
  }]
}, {
  path: '/',
  component: function component() {
    return import('layouts/App.vue');
  },
  redirect: '/dashboard',
  name: 'dashboard',
  meta: {
    auth: true,
    subscribed: true,
    setupCompleted: true,
    shortcut: true
  },
  children: [{
    path: 'dashboard',
    component: function component() {
      return import('pages/Dashboard.vue');
    }
  }, {
    path: 'timers',
    component: function component() {
      return import('pages/Timers.vue');
    }
  }, {
    path: 'tasks',
    name: 'tasks',
    meta: {
      feature: 'project_management'
    },
    component: function component() {
      return import('pages/Tasks.vue');
    }
  }, {
    path: 'projects',
    name: 'projects',
    component: function component() {
      return import('pages/Projects.vue');
    }
  }, {
    path: 'projects/:project_id',
    name: 'project_detail',
    component: function component() {
      return import('pages/Project.vue');
    },
    meta: {
      project: true
    }
  }, {
    path: 'entries-log',
    name: 'entries-log',
    meta: {
      mobile: true
    },
    component: function component() {
      return import('pages/EntriesLog.vue');
    }
  }, {
    path: 'timesheet',
    name: 'timesheet',
    meta: {
      feature: 'approval',
      mobile: true
    },
    component: function component() {
      return import('pages/Timesheets.vue');
    }
  }, {
    path: 'approval-requests',
    name: 'approval-requests',
    meta: {
      feature: 'approval',
      mobile: true
    },
    component: function component() {
      return import('pages/ApprovalRequests.vue');
    }
  }, {
    path: 'approval-requests/:approval_request_id',
    name: 'approval_request_detail',
    meta: {
      feature: 'approval',
      mobile: true
    },
    component: function component() {
      return import('pages/ApprovalRequest.vue');
    }
  }, {
    path: 'expenses',
    name: 'expenses',
    meta: {
      feature: 'expenses_management'
    },
    component: function component() {
      return import('pages/Expenses.vue');
    }
  }, {
    path: 'projects/:project_id/edit',
    name: 'project_edit',
    component: function component() {
      return import('pages/ProjectEdit.vue');
    },
    meta: {
      pm: true
    }
  }, {
    path: 'clients',
    name: 'clients',
    meta: {
      admin: true
    },
    component: function component() {
      return import('pages/Clients.vue');
    }
  }, {
    path: 'clients/:client_id',
    name: 'client_detail',
    meta: {
      admin: true
    },
    component: function component() {
      return import('pages/Client.vue');
    }
  }, {
    path: 'tags',
    name: 'tags',
    meta: {
      admin: true
    },
    component: function component() {
      return import('pages/Tags.vue');
    }
  }, {
    path: 'reports',
    name: 'reports',
    component: function component() {
      return import('pages/Reports.vue');
    }
  }, {
    path: 'reports/:report_type/:report_id?',
    name: 'report_detail',
    component: function component() {
      return import('pages/Report.vue');
    }
  }, {
    path: 'integrations',
    name: 'integrations',
    component: function component() {
      return import('pages/Integrations.vue');
    }
  }, {
    path: 'integrations/:integration_code',
    name: 'integration_detail',
    component: function component() {
      return import('pages/Integration.vue');
    }
  }, {
    path: 'profile',
    name: 'profile',
    component: function component() {
      return import('pages/Profile.vue');
    }
  }, {
    path: 'preferences/:tab?',
    name: 'email-preferences',
    redirect: function redirect(to) {
      return {
        name: 'profile',
        hash: to.params.tab ? '#' + to.params.tab : ''
      };
    }
  }, {
    path: 'developers',
    name: 'developers',
    meta: {
      feature: 'api'
    },
    component: function component() {
      return import('pages/Developers.vue');
    }
  }, {
    path: 'workspace-settings',
    name: 'workspace_settings',
    meta: {
      admin: true
    },
    alias: 'account',
    component: function component() {
      return import('pages/WorkspaceSettings.vue');
    }
  }, {
    path: 'expense-categories',
    name: 'expense-categories',
    meta: {
      feature: 'expenses_management',
      admin: true
    },
    alias: 'expense_categories',
    component: function component() {
      return import('pages/ExpenseCategories.vue');
    }
  }, {
    path: 'management',
    name: 'management',
    meta: {
      admin: true,
      mobile: true
    },
    component: function component() {
      return import('pages/Management.vue');
    }
  }, {
    path: 'notifications',
    name: 'notifications',
    meta: {
      mobile: true
    },
    component: function component() {
      return import('pages/Notifications.vue');
    }
  }, {
    path: 'status/:project_id-:slug',
    redirect: {
      name: 'project_detail'
    }
  }, {
    path: 'users',
    name: 'users',
    meta: {
      admin: true,
      subscribed: false
    },
    component: function component() {
      return import('pages/Users.vue');
    }
  }, {
    path: 'billing',
    name: 'billing',
    meta: {
      owner: true,
      subscribed: false
    },
    component: function component() {
      return import('pages/Billing.vue');
    }
  }, {
    path: 'trial-ended',
    name: 'trial-ended',
    meta: {
      owner: false,
      subscribed: false
    },
    component: function component() {
      return import('pages/TrialEnded.vue');
    }
  }, {
    path: 'subscription-expired',
    name: 'subscription-expired',
    meta: {
      owner: false,
      subscribed: false
    },
    component: function component() {
      return import('pages/SubscriptionExpired.vue');
    }
  }, {
    path: 'import',
    name: 'import',
    meta: {
      gm: true,
      feature: 'csv_imports'
    },
    component: function component() {
      return import('pages/Import.vue');
    }
  }]
}, {
  path: '*',
  redirect: '/dashboard'
}]; // Always leave this as last one

if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: function component() {
      return import('pages/Error404.vue');
    }
  });
}

export default routes;